import { render, staticRenderFns } from "./inspectScreen.vue?vue&type=template&id=0bc1fb72&scoped=true"
import script from "./inspectScreen.vue?vue&type=script&lang=js"
export * from "./inspectScreen.vue?vue&type=script&lang=js"
import style0 from "./inspectScreen.vue?vue&type=style&index=0&id=0bc1fb72&prod&lang=scss&scoped=true"
import style1 from "./inspectScreen.vue?vue&type=style&index=1&id=0bc1fb72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc1fb72",
  null
  
)

export default component.exports